import React, { useCallback, useMemo, useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { isEqual } from 'lodash';
import { Form, Input, InputNumber, notification } from 'antd';
import DF from 'DisplayFramework';
import DataGrid from 'components/DataGrid';
import { DataGridColDef } from 'components/DataGrid/DataGrid';

import { indexBy } from 'utils/utils2';
import UpdateButton from 'components/UpdateButtonAction';
import {
  getGuarValueById,
  GuarValue,
  UpdateGuarValue,
} from 'services/guaranty';

type Values = {
  garantyvalue: GuarValue[];
};
type GuarantyValueProps = {
  guarId?: number;
};

const GuarantyValue = (props: GuarantyValueProps) => {
  const { guarId } = props;
  const [form] = Form.useForm();
  const fieldName = 'garantyvalue';

  const [searchs, setsearchs] = useState(true);

  const { data, refetch, isFetching } = useQuery(
    ['getGuarValueById',Number(guarId)],
    () => getGuarValueById({ guarid: Number(guarId) }).then((res) => res.list || []),
    { enabled: searchs }
  );

  useEffect(() => {
    if (data) {
      form.setFieldsValue({ [fieldName]: data });
    } else {
      form.setFieldsValue({
        [fieldName]: [],
      });
    }
  }, [form, data]);

  const Update = useCallback(
    (record: GuarValue) => {
      const deprecations: GuarValue[] = form.getFieldValue(fieldName);
      const index = indexBy(deprecations, 'guarvalueid')[record.guarvalueid];
      const currentValue = {
        ...deprecations[index],
      };
      UpdateGuarValue({
        guarvalueid: currentValue.guarvalueid,
        request: currentValue,
      }).then((response) => {
        if (response.code === '200') {
          notification.success({
            message: response.message,
          });
          refetch();
        }
      });
    },
    [form, refetch]
  );
  const getName = useCallback(
    (name: string) => (record: GuarValue) => {
      const functions = form.getFieldValue(fieldName);
      const index = indexBy(functions, 'guarvalueid')[record.guarvalueid];

      return [fieldName, index, name];
    },
    [form]
  );
  const columns = useMemo<DataGridColDef<GuarValue>[]>(
    () => [
      // {
      //   dataIndex: 'guarid',
      //   fixed: 'left',
      // },
      // {
      //   dataIndex: 'guarvalueid',

      //   render: (value, record) => {
      //     return (
      //       <Form.Item noStyle name={getName('guarvalueid')(record)}>
      //         <Input />
      //       </Form.Item>
      //     );
      //   },
      // },

      {
        dataIndex: 'guaramount',
        render: (value, record) => {
          return (
            <Form.Item noStyle name={getName('guaramount')(record)}>
              <InputNumber min={0} />
            </Form.Item>
          );
        },
      },

      {
        dataIndex: 'startdate',

        render: (value, record) => {
          return (
            <Form.Item noStyle name={getName('startdate')(record)}>
              <Input />
            </Form.Item>
          );
        },
      },
      {
        dataIndex: 'enddate',
        render: (value, record) => {
          return (
            <Form.Item noStyle name={getName('enddate')(record)}>
              <Input />
            </Form.Item>
          );
        },
      },
      {
        dataIndex: 'status',

        render: (value, record) => {
          return (
            <Form.Item noStyle name={getName('status')(record)}>
              <Input />
            </Form.Item>
          );
        },
      },

      {
        key: 'actions',
        render: (_, _record) => (
          <UpdateButton
            onClick={(ev) => {
              ev.preventDefault();
              Update(_record);
            }}
            size="small"
            comcode="update"
          />
        ),
      },
    ],

    [getName, Update]
  );

  return (
    <DF.Provider pagcode="GuarantyValue">
      <Form form={form} initialValues={row}>
        <Form.Item
          noStyle
          shouldUpdate={(prevValue: Values, nextValue: Values) => {
            return !isEqual(prevValue, nextValue);
          }}
        >
          {({ getFieldValue }) => {
            const garantyvalue: GuarValue[] = getFieldValue(fieldName);

            return (
              <DataGrid
                rowKey="guarvalueid"
                dataSource={garantyvalue}
                titleComcode="GuarantyValue"
                columns={columns}
                onSearch={(values) => {
                  setsearchs(true);
                }}
                isLoading={isFetching}
              />
            );
          }}
        </Form.Item>
      </Form>
    </DF.Provider>
  );
};

const row: GuarValue = {
  enddate: '',
  guaramount: 0,
  guarid: 0,
  guarvalueid: 0,
  startdate: '',
  status: '',
};

export default GuarantyValue;
